// extracted by mini-css-extract-plugin
export var bottomDivider = "WordSliderModule-module--bottomDivider--1636b";
export var contentContainer = "WordSliderModule-module--contentContainer--a8f3d";
export var divider = "WordSliderModule-module--divider--3eb80";
export var lightColor = "WordSliderModule-module--lightColor--3e80f";
export var moduleDivider = "WordSliderModule-module--moduleDivider--71622";
export var rowContainer = "WordSliderModule-module--rowContainer--fb6a8";
export var slider = "WordSliderModule-module--slider--536ab";
export var word = "WordSliderModule-module--word--94102";
export var wordsContainer = "WordSliderModule-module--wordsContainer--300cc";